module.exports = __webpack_public_path__ + "static/media/StatSignedUpCircle.2be8ab7d.svg";